import { jsx as _jsx } from "react/jsx-runtime";
import { fileExtension, fileTypeColor } from './FileTypeIcon';
export function TypeBadge({ mime }) {
    const label = fileExtension(mime);
    const { bg, fg } = fileTypeColor(mime);
    return (_jsx("span", { className: "inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide", style: { backgroundColor: bg, color: fg }, children: label }));
}
//# sourceMappingURL=TypeBadge.js.map